import React, { useEffect, useState } from "react";
import "./NavBar.scss";
import {
  HiHomeModern,
  HiListBullet,
  HiInformationCircle,
  HiPhoto,
  HiPuzzlePiece,
  HiBuildingOffice2,
  HiPhone,
} from "react-icons/hi2";
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
import Logo from "../../assets/logo.png";
import LanguageToggle from "../LanguageToggle/LanguageToggle";

export default function NavBar() {
  const { t } = useTranslation("links");

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const BottomNavBarLinks = [
    {
      name: t("home"),
      href: "/",
      icon: <HiHomeModern />,
    },
    {
      name: t("menu"),
      href: "/menu",
      icon: <HiListBullet />,
    },
    {
      name: t("about_us"),
      href: "/about-us",
      icon: <HiInformationCircle />,
    },
    {
      name: t("gallery"),
      href: "/gallery",
      icon: <HiPhoto />,
    },
    {
      name: t("apartments"),
      href: "/apartments",
      icon: <HiBuildingOffice2 />,
    },
    {
      name: t("playroom"),
      href: "/playroom",
      icon: <HiPuzzlePiece />,
    },
  ];

  const ToNavBarLinks = [
    { name: t("great_hall"), href: "/great-hall" },
    { name: t("crystal_hall"), href: "/crystal-hall" },
    { name: t("small_hall"), href: "/small-hall" },
  ];
  return (
    <div className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar__content">
        <div className="navbar__top">
          <Link to={"tel:0652890653"} className="top-contact">
            <HiPhone /> {t("contact")}
          </Link>
          <div className="top-links">
            {ToNavBarLinks.map((link) => (
              <NavLink to={link.href} key={link.name} className={"top-link"}>
                {link.name}
              </NavLink>
            ))}
          </div>
        </div>
        <div className="navbar__bottom">
          <Link to={"/"} className="bottom-logo">
            <img src={Logo} alt="Logo Image" />
          </Link>
          <div className="bottom-links">
            {BottomNavBarLinks.map((link) => (
              <NavLink to={link.href} key={link.name} className={"bottom-link"}>
                {link.name}
              </NavLink>
            ))}
          </div>
          <LanguageToggle />
        </div>
      </div>
    </div>
  );
}
